"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Avatar = _interopRequireDefault(require("../../Avatar/Avatar"));
var _constants = require("../../constants");
var _Button = _interopRequireDefault(require("../../Button/Button"));
var _Svg = _interopRequireDefault(require("../../Svg/Svg"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var CustomizedItem = function CustomizedItem(_ref) {
  var item = _ref.item,
    index = _ref.index,
    isLast = _ref.isLast;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--items__item flex justify-between ".concat(!isLast ? ' margin-bottom-md' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--item__left flex margin-right-sm"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "left margin-right-sm"
  }, item.link ? /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    id: item.link.id,
    className: "unstyled ".concat(item.link.className || ''),
    href: item.link
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    avatarSize: _constants.AVATAR_SIZES.MEDIUM,
    avatarType: _constants.AVATAR_TYPES.CIRCLE,
    image: item.image,
    initials: item.initials.toUpperCase(),
    notificationText: item.crewMembers
  })) : /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    avatarSize: _constants.AVATAR_SIZES.MEDIUM,
    avatarType: _constants.AVATAR_TYPES.CIRCLE,
    image: item.image,
    initials: item.initials.toUpperCase(),
    notificationText: item.crewMembers
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "right text-component"
  }, item.link ? /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    id: item.link.id,
    className: "unstyled ".concat(item.link.className || ''),
    href: item.link
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "d8-u-font-size-base d8-u-ls-sm d8-u-font-primary d8-u-font-weight-300 d8-u-no-transform",
    style: {
      marginTop: 0
    }
  }, item.title)) : /*#__PURE__*/_react["default"].createElement("h4", {
    className: "d8-u-font-size-base d8-u-ls-sm d8-u-font-primary d8-u-font-weight-300 d8-u-no-transform"
  }, item.title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm d8-u-color-contrast-medium"
  }, item.icon && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    name: item.icon,
    className: "margin-right-xxs icon--xs",
    fill: _constants.COLORS.CONTRAST_MEDIUM
  }), item.subtitle, item.pill && /*#__PURE__*/_react["default"].createElement("span", {
    className: "pill margin-left-sm pill--sm text-sm d8-u-color-white ".concat(item.pill.type)
  }, item.pill.text)))), item.cta && /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--item__right text-right text-component flex-shrink-0"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], item.cta)));
};
CustomizedItem.propTypes = {
  item: _propTypes["default"].object,
  index: _propTypes["default"].number,
  isLast: _propTypes["default"].bool
};
CustomizedItem.deafultProps = {
  isLast: false
};
var _default = exports["default"] = CustomizedItem;